<ng-container *ngIf="data.title">
  <h2 mat-dialog-title class="center">{{data.title}}</h2>
</ng-container>

<mat-dialog-content class="center">
  <ng-container *ngIf="data.text">
    <span>{{ data.text }}</span>
  </ng-container>
  <ng-container *ngIf="data.imageSource">
    <img src="{{data.imageSource}}" alt="Dialog image">
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions >
  <ng-container *ngIf="data.isConfirmation">
    <button matButton [mat-dialog-close]="false">Cancel</button>
    <button matButton="filled" [mat-dialog-close]="true">Remove</button>
  </ng-container>
  <ng-container *ngIf="!data.isConfirmation">
    <button matButton mat-dialog-close>Cancel</button>
  </ng-container>
</mat-dialog-actions>